(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["st-melon-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('st-melon-offer')) {
    customElements.define('st-melon-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('button').addEventListener('click', () => {
          const form = this.closest('.cp__form');
          const melon = form && form.querySelector('input[type="radio"][name="option1"][value="Melon"]');
          if (melon) {
            melon.click();
            melon.focus({ preventScroll: true });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
